import React, { useState } from 'react';

const UserSettingsContext = React.createContext({});

const search = document.location.search || '';

const emailVerificationTokenMatch = search.match(/(\?e=|&e=)([^&]+)/) || [];
const emailVerificationToken = emailVerificationTokenMatch[2];

const passwordVerificationTokenMatch = search.match(/(\?p=|&p=)([^&]+)/) || [];
const passwordVerificationToken = passwordVerificationTokenMatch[2];

const signupTokenMatch = search.match(/(\?t=|&t=)([^&]+)/) || [];
const signupToken = signupTokenMatch[2];

const redirectMatch = search.match(/(\?r=|&r=|\?redirect=|&redirect=)([^&]+)/) || [];
const redirect = decodeURIComponent(redirectMatch[2] || '');

export function UserSettingsContextProvider({ children }) {
  const [userSettings, setUserSettings] = useState({
    emailVerificationToken,
    passwordVerificationToken,
    signupToken,
    redirect,
  });

  const checkAndSetUserSettings = (settings = {}) => {
    if (Object.keys(settings).some(k => settings[k] !== userSettings[k])) {
      setUserSettings(settings);
    }
  }

  const state = {
    userSettings,
    setUserSettings: checkAndSetUserSettings,
  };

  return (
    <UserSettingsContext.Provider value={state}>
      {children}
    </UserSettingsContext.Provider>
  );
}

export default UserSettingsContext;
